import { useEffect, useState } from 'react';

// Desktop and mobile are drawn separately, not one stretched layout.
export const DESIGN = {
  landscape: { width: 1440, height: 900 },
  portrait: { width: 390, height: 844 },
} as const;

export interface DesignViewport {
  portrait: boolean;
  width: number;
  height: number;
  scale: number;
  x: number;
  y: number;
}

function measure(): DesignViewport {
  const cw = window.innerWidth;
  const ch = window.innerHeight;
  const portrait = ch > cw;
  const design = portrait ? DESIGN.portrait : DESIGN.landscape;
  const scale = Math.min(cw / design.width, ch / design.height);
  return {
    portrait,
    width: design.width,
    height: design.height,
    scale,
    x: (cw - design.width * scale) / 2,
    y: (ch - design.height * scale) / 2,
  };
}

// Same fit as the Phaser scene, so overlays line up with the board.
export function useDesignViewport(): DesignViewport {
  const [viewport, setViewport] = useState<DesignViewport>(measure);

  useEffect(() => {
    const onResize = () => setViewport(measure());
    window.addEventListener('resize', onResize);
    window.addEventListener('orientationchange', onResize);
    return () => {
      window.removeEventListener('resize', onResize);
      window.removeEventListener('orientationchange', onResize);
    };
  }, []);

  return viewport;
}
